import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { Observable } from 'rxjs';
import { Node } from './../model/Node';

@Injectable({
  providedIn: 'root'
})
export class FilesService {

  constructor(private http: HttpClient) { }

  getDirectory(dirPath: string): Observable<Node> {
    return this.http.get<Node>(`${environment.apiUrl}/files/directories`, { params: { dirPath }, withCredentials: true });
  }

  deleteItem(node: Node): Observable<Node> {

    const body = {
      filePath: node.path
    };

    return this.http.delete<Node>(`${environment.apiUrl}/files/item`, {
      body: body,
      withCredentials: true
    });
  }

  createDirectory(name: string): Observable<Node> {
    return this.http.post<Node>(`${environment.apiUrl}/files/directories`, { dirPath: name }, { withCredentials: true });
  }

}
